const SCOPE = 'app/';
export const ActionTypes = {
    ERROR: `${SCOPE}ERROR`,
    PUSH_LOCATION: `${SCOPE}PUSH_LOCATION`,
    TICK: `${SCOPE}TICK`,
    SET_CATEGORIES: `${SCOPE}SET_CATEGORIES`,
    SET_DESTINATIONS: `${SCOPE}SET_DESTINATIONS`,
    SET_IS_FIRST_RENDER: `${SCOPE}SET_IS_FIRST_RENDER`,
    SET_PREFETCH_PROGRESS: `${SCOPE}SET_PREFETCH_PROGRESS`,
};

export const error = (err) => ({
    type: ActionTypes.ERROR,
    error: err,
});

export const pushLocation = (location = '/') => ({
    type: ActionTypes.PUSH_LOCATION,
    location,
});

export const tick = () => ({
    type: ActionTypes.TICK,
});

export const setDestinations = (destinations = []) => ({
    type: ActionTypes.SET_DESTINATIONS,
    destinations,
});

export const setCategories = (categories = []) => ({
    type: ActionTypes.SET_CATEGORIES,
    categories,
});

export const setIsFirstRender = (isFirstRender) => ({
    type: ActionTypes.SET_IS_FIRST_RENDER,
    isFirstRender,
});

export const setPrefetchProgress = ({ total, loaded, loading }) => ({
    type: ActionTypes.SET_PREFETCH_PROGRESS,
    total,
    loaded,
    loading,
});
